import Bootstrapper from './Bootstrapper';

export default Bootstrapper;
